import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} stores
 * @returns {Workbook}
 */
export const exportExcel = async (stores) => {
  stores.forEach((store, index) => (store.order = index + 1));

  const json = excelHelper.jsonToJson(
    [stores],
    [
      {
        name: "TIENDAS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "ruc",
            outValue: "RUC",
          },
          {
            inValue: "businessName",
            outValue: "RAZON SOCIAL",
          },
          {
            inValue: "address",
            outValue: "DIRECCION",
          },
          {
            inValue: "phone",
            outValue: "NUMERO TELEFONICO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-tiendas.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreList/excel.js